module.exports = __webpack_public_path__ + "static/media/[Philm]2010-07-17-1.17a2fbd4.md";